"use client"

import styled from "@emotion/styled"

import { baseTheme } from "@/shared-module/common/styles"

const YellowBox = styled.div`
  padding: 1rem;
  background-color: ${baseTheme.colors.yellow[200]};
  color: #493f13;
  margin: 1rem 0;
  font-size: 1rem;
  line-height: 140%;
  text-align: center;
  border-radius: 0.25rem;
`

export default YellowBox
